import { useParams } from "react-router-dom";

import { ROUTES } from "@/constants/routes";
import { SEGMENT_DETAIL_PARAM } from "@/features/segments/pages/overview/constants";

export const useSegmentPaths = () => {
  const { clientId } = useParams();
  const overview = clientId
    ? `/${ROUTES.clients}/${clientId}/${ROUTES.segments}`
    : `/${ROUTES.segments}`;

  return {
    overview,
    overviewSelected: (segmentId: string) =>
      `${overview}?${new URLSearchParams({ [SEGMENT_DETAIL_PARAM]: segmentId })}`,
    view: (segmentId: string) => `${overview}/${segmentId}`,
    edit: (segmentId: string) => `${overview}/${segmentId}/${ROUTES.edit}`,
  };
};
